<template>
  <div id="app" :class="{
    main: $route.meta.main,
    touch,
    'no-touch': !touch,
    en: lang === 'en',
    freeze,
  }">
    <AppHeader />
    <div class="pseudo-body" :style="`height: ${scrollHeight}px`"></div>
    <div class="app-scroll-container">
      <div class="app-scroll-body" :style="`transform: translateY(-${scrollValue}px)`">
        <router-view />
        <AppFooter />
      </div>
    </div>
    <div class="stick-container"></div>
    <div class="stick-container2"></div>
    <chuncheon-popup />
    <div class="video-popup" v-if="popupVideo">
      <div class="video-popup-body">
        <iframe :src="`https://tv.naver.com/embed/${popupVideo}?autoPlay=true`" frameborder="no" scrolling="no"
          marginwidth="0" marginheight="0" WIDTH="544" HEIGHT="306" allow="autoplay" allowfullscreen></iframe>
        <div class="close" @click="closePopup"></div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import AppHeader from "@/views/common/AppHeader";
import AppFooter from "@/views/common/AppFooter";
import {
  getOffsetLeft,
  getOffsetTop,
  getScrollBody,
  isTouch,
  numberAnimate,
} from "@/utils";
import responsive from "@/utils/responsive";
import ChuncheonPopup from "@/views/pages/gak/ChuchoenPopup";

export default {
  name: "app",
  components: {
    ChuncheonPopup,
    AppFooter,
    AppHeader,
  },
  data() {
    return {
      touch: false,
      scrollHeight: 0,
      scrollBody: null,
      scrollValue: 0,
      scrollTarget: 0,
      qList: [],
      jList: [],
      stepList: [],
      // jumping: false,
    };
  },
  computed: {},
  methods: {
    tick() {
      if (this.freeze) this.scrollHeight = 0;
      else if (this.scrollBody.offsetHeight !== this.scrollHeight)
        this.scrollHeight = this.scrollBody.offsetHeight;
        const delta = this.scrollTarget - this.scrollValue;
      if (Math.abs(delta) < 1) {
        this.scrollValue = this.scrollTarget;
      } else {
        // this.scrollValue += delta * (this.jumping ? 0.05 : 0.1);
        this.scrollValue += delta * 0.1;
      }
      this.changeSv(this.scrollValue);
    },
    findStep() {
      let i,
        result = -1;

      let pList = [];
      for (i = 0; i < this.jList.length; ++i) {
        pList[i] =
          getOffsetTop(this.jList[i]) -
          (this.jList[i].getAttribute("data-offset") || 64);
      }
      this.stepList = _.sortBy(pList);

      const h = getScrollBody().clientHeight;
      for (let i = 0; i < this.stepList.length; ++i) {
        if (this.stepList[i] - this.sv < 1) continue;
        if (this.stepList[i] - this.sv < h) {
          result = i;
          break;
        }
      }
      return result;
    },
    onWheel() {
      if (this.sdir !== "down") return;
      // const step = this.findStep(this.scrollTarget);
      // if (step > -1) {
      //   this.scrollTarget = this.stepList[step];
      //   getScrollBody().scrollTop = this.stepList[step];
      //   // this.jumping = true;
      // }
    },
    scrolled() {
      if (this.freeze) return;
      // this.jumping = false;
      if (!this.touch) {
        this.scrollTarget = getScrollBody().scrollTop;
      } else {
        this.changeSv(getScrollBody().scrollTop);
      }
    },
    changeSv(val) {
      if (!this.freeze)
        this.$store.commit(
          "scrollDir",
          val >= 64 && val >= this.sv ? "down" : "up"
        );
      this.$store.commit("scroll", val);
      this.scrollRender();
    },
    scrollRender() {
      if (this.onFix) return;
      const val = this.sv;
      // eslint-disable-next-line no-unused-vars
      let ot, ob, t, e, b, c, lr, eb, i, o, otb, bot;
      const opr = 200;
      let h = getScrollBody().clientHeight;
      const et = Math.min(h * 0.2, 300);
      for (i = 0; i < this.qList.length; ++i) {
        e = this.qList[i];
        t = getOffsetTop(e);
        b = t + e.offsetHeight;
        lr = getOffsetLeft(e) / window.innerWidth;
        eb = Math.min(h * (0.15 + lr * 0.2), 300);
        ob = b - val;
        ot = t - val;
        if (e.nh) {
          if (!e.na && ot < h - 100) numberAnimate(e);
          continue;
        }
        /*
        otb = e.ub ? ob : ot;
        bot = e.ub ? h : h - eb;
        */
        otb = ot;

        if (e.ub) {
          bot = h - eb + 130;
          e.setAttribute(
            "data-status",
            otb > bot
              ? "down"
              : // : ob < et ? 'up'
              "in"
          );
        } else {
          bot = h - eb;
          c =
            ob < -h * 0.5
              ? 0
              : ot > h * 1.2
                ? 0
                : ob < et && !e.i
                  ? ob - et
                  : otb > bot && !e.o
                    ? otb - bot
                    : 0;

          o = c <= 0 ? opr : c > opr ? 0 : opr - c;

          e.style.transform = `translateY(${c}px)`;
          e.style.opacity = `${o / opr}`;
        }
      }
    },
    resized({ section }) {
      this.changeSv(getScrollBody().scrollTop);
      this.$store.commit("section", section);
      this.refreshQ();
    },
    reloadLink() {
      getScrollBody().scrollTop = 0;
    },
    refreshQ() {
      this.$nextTick(() => {
        this.qList = document.querySelectorAll("q, .q, [data-num]");
        let i, t0;
        for (i = 0; i < this.qList.length; ++i) {
          this.qList[i].o = this.qList[i].hasAttribute("out-only");
          this.qList[i].i = true; //this.qList[i].hasAttribute('in-only');
          this.qList[i].ub = this.qList[i].hasAttribute("q-card");
          // eslint-disable-next-line no-cond-assign
          if ((t0 = this.qList[i].getAttribute("data-num"))) {
            t0 = t0.split(",");
            this.qList[i].nh = true;
            this.qList[i].ns = +t0[0];
            this.qList[i].ne = +t0[1];
          }
        }
        
        this.jList = document.querySelectorAll(".j");

        _.forEach(document.querySelectorAll(".router-link-active"), (el) => {
          el.addEventListener("click", this.reloadLink);
        });
        this.scrollRender();
      });
    },
    closePopup() {
      this.$store.commit("showVideo", false);
    },
  },
  watch: {
    $route() {
      this.scrollValue = 0;
      this.refreshQ();

      if (process.env.VUE_APP_BUILD_NAME === "staging") {
        if (this.initialRouter) {
          this.$addAnalytics();
          this.initialRouter = false;
        } else {
          this.$reAddAnalytics();
        }
      }
    },
    freeze(val) {
      if (!val) {
        if (this.touch) {
          //this.scrollHeight = this.scrollBody.offsetHeight;
          this.$nextTick(() => {
            getScrollBody().scrollTop = this.scrollValue;
            this.scrollValue = 0;
          });
        } else {
          this.scrollHeight = this.scrollBody.offsetHeight;
          this.$nextTick(() => {
            getScrollBody().scrollTop = this.scrollTarget;
          });
        }
      } else {
        if (this.touch) {
          this.scrollValue = getScrollBody().scrollTop;
        }
      }
    },
  },
  mounted() {
    this.touch = isTouch();
    this.scrollBody = this.$el.querySelector(".app-scroll-body");
    if (!this.touch) {
      setInterval(this.tick, 16);
    } else {
      this.scrolled();
    }
    window.addEventListener("scroll", this.scrolled);
    window.addEventListener("wheel", _.debounce(this.onWheel, 20));
    responsive.addListener(this.resized);
  },
  created() {},
};
</script>

<style lang="less">
@import "~@/less/common";

html,
body,
#app {
  .hf;
}

html {
  overflow-y: scroll;
}

q {
  .ib;
  .vat;
}

.app-scroll-body {
  .pt(120);
}

.main .app-scroll-body {
  .pt(64);
}

.stick-container, .stick-container2 {
  .fix;
  .pt(55);
  .t(0);
  .wf;
}

.stick-container2 {
  .hide;
}

.no-touch .app-scroll-container {
  .fix;
  .lt;
  .wf;
  .hf;
  overflow: hidden;
}

.freeze .app-scroll-container {
  .fix;
  .lt;
  .wf;
  .hf;
  overflow: hidden;
}

.video-popup {
  .fix;
  .wh(100%, 100%);
  .lt;
  z-index: 101;

  &:before {
    .cnt;
    .abs;
    .wh(100%, 100%);
    .bgc(rgba(0, 0, 0, 0.8));
  }

  .video-popup-body {
    .abs;
    .lt(50%, 50%);
    transform: translate(-50%, -50%);

    iframe {
      .wh(100vw, 56vw);
    }

    .close {
      .wh(28, 28);
      .rt(0, -30);
      .abs;
      .bg-contain("@{common}/video-close.svg");
    }
  }
}

@media (min-width: @screen-md-min) {
  .video-popup {
    .video-popup-body {
      iframe {
        .wh(576, 324);
      }
    }
  }
}

@media (min-width: @screen-lg-min) {
  .video-popup {
    .video-popup-body {
      iframe {
        .wh(768, 432);
      }
    }
  }

  .app-scroll-body {
    .pt(64);
  }

  .stick-container, .stick-container2 {
    .pt(64);
  }
}

@media (min-width: @screen-xl-min) {
  .video-popup {
    .video-popup-body {
      iframe {
        .wh(1200, 675);
      }
    }
  }
}

@media (min-width: @screen-xxl-min) {
  .video-popup {
    .video-popup-body {
      iframe {
        .wh(1200, 675);
      }
    }
  }
}
</style>

<style lang="less">
@import "~@/less/dc/gak-common";
@import "~@/less/dc/global";
@import "~@/less/dc/chuncheon";
@import "~@/less/dc/sejong";
@import "~@/less/about/our-data";
@import "~@/less/about/our-idea";
@import "~@/less/about/our-brand";
@import "~@/less/tech/technology";
// 예전 tech/people.less 머리에 있던 전역 규칙입니다. [people] 범위 밖이라 사이트 전체 img·h2·h3 에 적용되고 있어
// 파일을 지운 뒤에도 같은 순서 위치에 그대로 둡니다(h2·h3 의 굵기·흰색이 여기서 정해집니다).
img {
  .block;
  .wh(100%);
  object-fit: cover;
}
h2,
h3 {
  .keep-all;
  .medium;
  color: #fff;
}
@import "~@/less/tech/timeline";
@import "~@/less/esg/green-energy";
@import "~@/less/esg/leed-platinum";
@import "~@/less/main/main";
</style>
